import _objectSpread from "@babel/runtime/helpers/objectSpread";
// import * as AttributesList from "./attributes";
// import * as Category from "./category";
// import { Attributes, AttributesVariables } from "./gqlTypes/Attributes";
// import {
//  CategoryDetails,
//  CategoryDetailsVariables,
// } from "./gqlTypes/CategoryDetails";
// import { ProductList, ProductListVariables } from "./gqlTypes/ProductList";
// import {
//  VariantsProducts,
//  VariantsProductsVariables,
// } from "./gqlTypes/VariantsProducts";
import * as Orders from "./orders";
import * as Product from "./products";
import * as Shop from "./shop";
import * as User from "./user";
import * as WishlistQuery from "./wishlist";
// TODO: Add ability to pass custom fragments to queries
export var QUERIES = {
  //  Attributes: <TCacheShape>(
  //    client: ApolloClient<TCacheShape>,
  //    options: QueryOptions<AttributesVariables>
  //  ): ObservableQuery<Attributes, any> =>
  //    client.watchQuery({
  //      query: AttributesList.attributes,
  //      ...options,
  //    }),
  //  CategoryDetails: <TCacheShape>(
  //    client: ApolloClient<TCacheShape>,
  //    options: QueryOptions<CategoryDetailsVariables>
  //  ): ObservableQuery<CategoryDetails, any> =>
  //    client.watchQuery({
  //      query: Category.categoryQuery,
  //      ...options,
  //    }),
  GetShopDetails: function GetShopDetails(client, options) {
    return client.watchQuery(_objectSpread({
      query: Shop.getShop
    }, options));
  },
  OrderDetails: function OrderDetails(client, options) {
    return client.watchQuery(_objectSpread({
      query: User.orderDetailsByTokenQuery
    }, options));
  },
  OrdersByUser: function OrdersByUser(client, options) {
    return client.watchQuery(_objectSpread({
      query: Orders.ordersByUser
    }, options));
  },
  ProductDetails: function ProductDetails(client, options) {
    return client.watchQuery(_objectSpread({
      query: Product.productDetails
    }, options));
  },
  // ProductList: <TCacheShape>(
  //  client: ApolloClient<TCacheShape>,
  //  options: QueryOptions<ProductListVariables>
  // ): ObservableQuery<ProductList, any> =>
  //  client.watchQuery({
  //    query: Product.productListDetails,
  //    ...options,
  //  }),
  UserDetails: function UserDetails(client, options) {
    return client.watchQuery(_objectSpread({
      query: User.getUserDetailsQuery
    }, options));
  },
  // VariantsProducts: <TCacheShape>(
  //  client: ApolloClient<TCacheShape>,
  //  options: QueryOptions<VariantsProductsVariables>
  // ): ObservableQuery<VariantsProducts, any> =>
  //  client.watchQuery({
  //    query: Product.variantsProducts,
  //    ...options,
  //  }),
  Wishlist: function Wishlist(client, options) {
    return client.watchQuery(_objectSpread({
      query: WishlistQuery.userWishlist
    }, options));
  }
};